import Phaser from "phaser";
import VenueDefinition from "./VenueDefinition";
import LiveWorldScene, {LiveAppContext} from "./LiveWorldScene";
import MainVenue from "./venues/main/MainVenue";
import moment from "moment";
import {BaseSession} from "./SessionizeDataProvider";

type Tilemap = Phaser.Tilemaps.Tilemap;

export default class SesstionizeWorldScene extends LiveWorldScene {
    constructor(
        worldKey: string,
        mapKey: string,
        public videoKey: string,
        backOnBounds: boolean,
        appContext: LiveAppContext,
        venue: VenueDefinition) {
        super(worldKey, mapKey, backOnBounds, appContext, venue);
    }

    create() {
        super.create();
        this.events.on('shutdown', () => {
            const mainVenueData = this.venue as MainVenue
            mainVenueData.sessionizeData.clearListeners()
            mainVenueData.venueDataProvider.clearListeners()
        })
    }

    processMapFeatures(map: Tilemap) {
        super.processMapFeatures(map);

        const roomSignBoxes = map.filterObjects("Objects", (obj) => {
            return obj.type === "RoomSign"
        })

        roomSignBoxes.forEach((obj) => this.makeRoomSignTrigger(obj as Phaser.GameObjects.Shape))

        const roomChangeBoxes = map.filterObjects("Objects", (obj) => {
            return obj.type === "RoomChange"
        })

        roomChangeBoxes.forEach((obj) => this.makeRoomChangeTrigger(obj as Phaser.GameObjects.Shape))

        const roomNameFloorSignNodes = map.filterObjects("Objects", (obj) => {
            return obj.type === "RoomNameFloorSign"
        })

        roomNameFloorSignNodes.forEach((obj) => this.makeRoomNameFloorSign(obj as Phaser.GameObjects.Shape))

        const mainVenue = this.venue as MainVenue
        mainVenue.furnitureProvider.processMapFeatures(map, "Objects", this)
        // (this.venue as MainVenue).furnitureProvider.processMapFeatures(map, "Objects", this)
    }

    makeRoomNameFloorSign(sb: Phaser.GameObjects.Shape){
        const bt = this.add.bitmapText(sb.x, sb.y, "gamefont_small_gray", "");

        const mainVenueData = this.venue as MainVenue
        mainVenueData.sessionizeData.listen(provider => {
            const roomId = parseInt(this.venue.venueValue(sb.name))
            const roomSession = mainVenueData.sessionizeData.sessions.find((session) => session.roomId === roomId)
            const stringValue = roomSession ? roomSession.room : ""
            bt.setText(stringValue.toUpperCase())
            const startX = sb.x
            if(bt.width > 0)
                bt.x = startX - (bt.width/2)
        })
    }

    makeRoomSignTrigger(signBox: Phaser.GameObjects.Shape) {
        const sbBox = this.physics.add.staticSprite(signBox.x + 16, signBox.y + 16, "empty")
        sbBox.setSize(signBox.width, signBox.height);

        this.addCollide(sbBox, () => {
            const mainVenueData = this.venue as MainVenue
            const sess = mainVenueData.sessionizeData.findCurrentSessionInfo(parseInt(signBox.name))

            const seshName = sess ? this.makeSessionTitle(sess) : "Session not found..."
            // let playTable = this.physics.add.staticGroup()
            const x = signBox.x + (signBox.width / 2)
            const y = (signBox.y + (signBox.height / 2))

            let textObject = this.add.text(x, y, seshName,
                {
                    padding: 6,
                    fontSize: '24px',
                    fontFamily: 'courier, courier new, serif'
                });

            textObject.x = textObject.x - (textObject.width / 2)
            textObject.y = textObject.y - (textObject.height + 35)
            textObject.setShadow(3, 3, 'rgba(0,0,0,0.5)', 5);
            textObject.setBackgroundColor("#aa6600")
            textObject.setDepth(100)

            this.onDoneTouching = () => textObject.destroy()
        })
    }

    makeSessionTitle(sess:BaseSession):string{
        const mom = moment(sess.startsAt)
        const d = mom.toDate()
        let isoDateString = moment(d).toISOString();
        console.log("toISOString", `${isoDateString}`)


        const startDate = mom.format(this.dateFormat)
        const startTime = mom.format("h:mm")
        const endTime = moment(sess.endsAt).format("h:mm a")

        return `-- Room --\n${sess.room}\n\n-- Next Session --\n${sess.title}\n\n${startDate} ${startTime}-${endTime}`
    }

    makeRoomChangeTrigger(sb: Phaser.GameObjects.Shape) {

        const sbBox = this.physics.add.staticSprite(sb.x + (sb.width / 2), sb.y + (sb.height / 2), "empty")
        sbBox.setSize(sb.width, sb.height);

        this.addCollide(sbBox, () => {
            const seshName = "Room closed until \n5 minutes before session start"
            // let playTable = this.physics.add.staticGroup()
            const x = sb.x + (sb.width / 2)
            const y = (sb.y + (sb.height / 2))

            let textObject = this.add.text(x, y, seshName,
                {
                    padding: 6,
                    fontSize: '24px',
                    fontFamily: 'courier, courier new, serif'
                });

            textObject.x = textObject.x - (textObject.width / 2)
            textObject.y = textObject.y - (textObject.height + 35)
            textObject.setShadow(3, 3, 'rgba(0,0,0,0.5)', 5);
            textObject.setBackgroundColor("#aa6600")
            textObject.setDepth(100)

            this.onDoneTouching = () => textObject.destroy()
        })
    }




}

